import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, catchError, first } from 'rxjs/operators';
import { NgxPermissionsService } from 'ngx-permissions';

import { environment } from '@env';
import { ProfileMember } from '@shared/models';

@Injectable({
    providedIn: 'root'
})
export class ProfileService {
    constructor(
        private router: Router,
        private http: HttpClient,
        private ngxPermissionsService: NgxPermissionsService
    ) { }

    /**
     * Get member data
     */
    get(): Observable<getResponse> {
        return this.http.get<getResponse>(`${environment.apiUrl}profile`);
    }

    /*resetPassword(token: string, password: string, password_confirmation: string): Observable<resetPasswordResponse> {
        return this.http.post<resetPasswordResponse>(`${environment.apiUrl}auth/password/reset`, {
            token,
            password,
            password_confirmation
        })
    }*/

    updateMemberData(memberId: number, data: any): Observable<updateMemberDataResponse> {
        return this.http.post<updateMemberDataResponse>(`${environment.apiUrl}profile/member/${memberId}/update`, data);
    }

    updateMemberPassword(memberId: number, data: any): Observable<updateMemberPasswordResponse> {
        return this.http.post<updateMemberPasswordResponse>(`${environment.apiUrl}profile/member/${memberId}/update-password`, data);
    }

    addMember(data: any): Observable<addMemberResponse> {
        return this.http.post<addMemberResponse>(`${environment.apiUrl}profile/member/create`, data);
    }

    updateHouseholdData(householdId: number, data: any): Observable<updateHouseholdDataResponse> {
        return this.http.post<updateHouseholdDataResponse>(`${environment.apiUrl}profile/household/${householdId}/update`, data);
    }

    getProfilePictureHelp(): Observable<getProfilePictureHelpResponse> {
        return this.http.get<getProfilePictureHelpResponse>(`${environment.apiUrl}profile/picture_help`);
    }

    uploadProfilePicture(memberId: number, file: File): Observable<uploadProfilePictureResponse> {
        let formData: FormData = new FormData();
        formData.append('uploadFile', file, file.name);

        let headers: HttpHeaders = new HttpHeaders();
        // headers.append('Content-Type', 'multipart/form-data');
        headers.append('Accept', 'application/json');

        return this.http.post<uploadProfilePictureResponse>(`${environment.apiUrl}profile/${memberId}/picture`, formData, {
            headers: headers,
        });
    }

    purchaseMemberCard(memberId: number): Observable<purchaseMemberCardResponse> {
        return this.http.post<purchaseMemberCardResponse>(`${environment.apiUrl}profile/${memberId}/purchase_member_card`, {});
    }

    setMembercardViewAccess(memberId: number, access: boolean): Observable<setMembercardViewAccessResponse> {
        return this.http.post<setMembercardViewAccessResponse>(`${environment.apiUrl}profile/${memberId}/set_membercard_view_access`, {
            access: access
        });
    }
}

export interface getResponse {
    member: ProfileMember
}

export interface updateMemberDataResponse {
    message: string;
}

export interface updateMemberPasswordResponse {
    message: string;
}

export interface addMemberResponse {
    message: string;
}

export interface updateHouseholdDataResponse {
    message: string;
}

export interface getProfilePictureHelpResponse {
    html: string;
}

export interface uploadProfilePictureResponse {
    prev_status: string;
    show_payment_option: boolean;
}

export interface purchaseMemberCardResponse {
    transaction_id: number;
    payment_url: string;
}

export interface setMembercardViewAccessResponse {
    success: boolean;
}
